import React from 'react';
import { autobind } from '../../../core/lib';

export interface IDimensions {
    width: number;
    height: number;
}

export interface IChildrenOptions {
    ref: Exclude<React.Ref<HTMLElement>, string>;
    dimensions?: IDimensions;
}

export interface IMeasurerProps {
    children(options: IChildrenOptions): JSX.Element;
}

export interface IMeasurerState {
    dimensions?: IDimensions;
}

export class Measurer extends React.PureComponent<IMeasurerProps, IMeasurerState> {
    public state: IMeasurerState = {};

    @autobind
    private measure(el: HTMLElement): void {
        if (el) {
            this.setState({
                dimensions: {
                    width: el.clientWidth,
                    height: el.clientHeight
                }
            });
        }
    }

    public render(): JSX.Element {
        const { children } = this.props;
        const { dimensions } = this.state;

        return React.Children.only(
            children({
                dimensions,
                ref: this.measure
            })
        );
    }
}



// WEBPACK FOOTER //
// ./src/packages/components/lib/Measure/index.tsx